import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';
import { normalizeListResponse, buildPaginationMeta } from './normalizers';

const BASE_URL = COMMUNITY_ENDPOINTS.LEARNING_PATHS;

export const getAll = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const getLevels = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/levels/`, { params });

export const getById = (id) =>
  communityHttpClient.get(`${BASE_URL}/${id}/`);

export const create = (data) =>
  communityHttpClient.post(`${BASE_URL}/`, data);

export const update = (id, data) =>
  communityHttpClient.put(`${BASE_URL}/${id}/`, data);

export const remove = (id) =>
  communityHttpClient.delete(`${BASE_URL}/${id}/`);

export const approve = (id, approved = true) =>
  communityHttpClient.post(`${BASE_URL}/${id}/approve/`, { approved });

export const getRelated = (id) =>
  communityHttpClient.get(`${BASE_URL}/${id}/related/`);

export const getFeatured = () =>
  communityHttpClient.get(`${BASE_URL}/featured/`);

export const getNormalizedList = async (params = {}) => {
  const response = await getAll(params);
  const normalized = normalizeListResponse(response.data);
  const meta = buildPaginationMeta({
    response: normalized,
    page: typeof params.page === 'number' ? params.page : Number(params.page) || 1,
    pageSize: typeof params.page_size === 'number'
      ? params.page_size
      : Number(params.page_size || params.pageSize || 0)
  });

  return {
    data: normalized.results,
    meta
  };
};

export default {
  getAll,
  getLevels,
  getById,
  create,
  update,
  delete: remove,
  remove,
  approve,
  getRelated,
  getFeatured,
  getNormalizedList
};
